import React from 'react';
import { connect } from 'react-redux';
import { showSavedSearchModal } from 'store/actions/globalActions';
import PermissionButton from 'elements/common/permission/PermissionButton';

const Bookmarks = props => (
  <PermissionButton permission="savesearch" className="bookmarks" onClick={props.showSavedSearchModal} ariaLabel="show saved searches" />
);

const mapDispatchToProps = {
  showSavedSearchModal,
};

export default connect(null, mapDispatchToProps)(Bookmarks);
